import css from './test.module.scss';

import { memo } from 'react';

import Button from 'core/ui/Button';

type FooterProps = {
  pos: number;
  setPos: (pos: number) => void;
  questionCount: number;
  wrongAttempts: number;
};

function Footer({ pos, setPos, questionCount, wrongAttempts }: FooterProps) {
  return (
    <div className={css.actions}>
      <Button
        className={css.button}
        disabled={pos < 1}
        onClick={() => setPos(pos - 1)}
        kkb="ArrowLeft"
      >
        Previous
      </Button>
      <div className={css.info}>
        <div className={css.pos}>
          {pos + 1} / {questionCount}
        </div>
        {wrongAttempts > 0 && (
          <div className={css.wrongCounter}>{wrongAttempts}</div>
        )}
      </div>
      <Button
        className={css.button}
        disabled={pos >= questionCount - 1}
        onClick={() => setPos(pos + 1)}
        kkb="ArrowRight"
      >
        Next
      </Button>
    </div>
  );
}

export default memo(Footer);
